import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/service/api.service';
import { GetterService } from 'src/app/service/getter-service.service';
import { Product } from 'src/Model/Product-Interfaces';
import { SelectDeliveryType } from '../../select-delivery-type/select-delivery-type.service';
import { ProductCardService } from '../product-card.service';
import { ThemeService } from 'src/app/service/theme.service';
import { brandFlavor as currentBrandFlavor } from 'src/app/brand/brand-context';

@Component({
  selector: 'app-responsive-grid-style',
  templateUrl: './responsive-grid-style.component.html',
  styleUrls: ['./responsive-grid-style.component.scss'],
})
export class ResponsiveGridStyleComponent implements OnInit, OnDestroy {
  @Input() products: Product[] = [];
  /** legacy category-products: a tap opens /products/product-details/:id in a new tab */
  @Input() redirectToDetails: boolean = false;
  @Output() quantityChanged = new EventEmitter();
  LandingPostcodeValidation: boolean;
  PopupOnKgItems: boolean;
  /* kg picker: numeric options; compareWith tolerates a quantity stored as "1.0" (string) or 1 */
  readonly kgOptions = [0.5, 1, 1.5, 2, 2.5, 3];
  sameQty = (a: any, b: any) => +a === +b;
  /** the six presets plus whatever is already in the basket (an odd weight from an older build) */
  kgChoices(current: any): number[] {
    const q = +current;
    return q && !this.kgOptions.some((w) => w === q)
      ? [...this.kgOptions, q].sort((a, b) => a - b)
      : this.kgOptions;
  }
  /* ngx-spinner cannot read CSS custom properties, so the resolved tokens are
     handed to it as plain colours */
  spinnerColor = '#e11d62';
  spinnerBackdrop = 'rgba(0, 0, 0, 0.5)';
  deliveryTypePopup: boolean;
  webCusSub: Subscription;
  CurrencySymbol: string;
  constructor(
    private apiService: ApiService,
    private _local: GetterService,
    private productCardService: ProductCardService,
    private selectService: SelectDeliveryType,
    private theme: ThemeService
  ) {}

  ngOnInit(): void {
    this.getWebcustomer();
  }
  ngOnDestroy(): void {
    this.webCusSub.unsubscribe();
  }
  getWebcustomer() {
    this.webCusSub = this.apiService.getWebcustomer$.subscribe((res) => {
      if (!res) {
        return;
      }
      this.CurrencySymbol = res.TemplateData.CurrencySymbol || 'GBP';

      this.deliveryTypePopup = res.TemplateData?.DeliveryTypePopup;
      this.spinnerColor = this.theme.token('--ui-accent', this.spinnerColor);
      this.spinnerBackdrop = this.theme.token('--ui-scrim', this.spinnerBackdrop);
      this.PopupOnKgItems = res.TemplateData?.AdditionalDetail?.PopupOnKgItems;
      this.LandingPostcodeValidation =
        res.TemplateData.CheckoutDetail.LandingPostcodeValidation;
    });
  }
  addRemoveFavourite(product: Product, status: boolean) {
    if (!this._local.get('CustomerId')) {
      this.openUrl('login');
      return;
    }
    this.productCardService.addRemoveFavs(product, status);
  }
  quantityControl(product: Product, flag: string) {
    this.productCardService.quantityControl(product, flag);
    this.quantityChanged.emit();
  }
  getProductModal(product: Product) {
    if (this.redirectToDetails) {
      // legacy category-products: open the product's own details page
      const brandFlavor = currentBrandFlavor();
      window.open(
        `${window.location.protocol}//${window.location.host}/${brandFlavor}/products/product-details/${product.ProductId}`,
        '_blank'
      );
      return;
    }
    if (this.deliveryTypePopup && !this._local.get('deliveryType')?.length) {
      this.selectService.showPopup.next();
      return;
    }
    this.productCardService.getProductModal(product);
  }
  openUrl(url: string) {
    this.productCardService.openUrl(url);
  }
  hasOptions(product: Product): boolean {
    return this.productCardService.hasOptions(product);
  }

  inBasket(product: Product): number {
    return this.productCardService.inBasket(product);
  }

  kgListChanged(product: Product) {
    this.productCardService.kgListChanged(product);
  }
}
